import React from "react";

const AppDrawer = ({ children }) => {
  return <>{children}</>;
};

export default AppDrawer;
